import { UNAUTHORIZED_USER_AUTHENTICATED } from '../actions/types'

const authorizationCode = (state = '', action) => {
  switch (action.type) {
    case UNAUTHORIZED_USER_AUTHENTICATED:
      return action.payload
    default:
      return state
  }
}

export { authorizationCode }
